import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { Divider } from 'primeng/divider';
import { ProgressSpinner } from 'primeng/progressspinner';
import { Message } from 'primeng/message';
import { Subscription } from 'rxjs';
import { DrawingFileService } from '../../../../../services/drawing-file.service';
import { DrawingFile } from '../../../../../../models/drawing-file.model';
import { PdfViewerComponent } from '../../../../../shared/pdf-viewer/pdf-viewer.component';
import { DrawingExtractionInfoComponent } from '../../../../../shared/drawing-extraction-info/drawing-extraction-info.component';

@Component({
  selector: 'app-quote-item-linked-drawing-modal',
  imports: [
    Dialog,
    Divider,
    ProgressSpinner,
    Message,
    PdfViewerComponent,
    DrawingExtractionInfoComponent,
  ],
  templateUrl: './quote-item-linked-drawing-modal.component.html',
})
export class QuoteItemLinkedDrawingModalComponent
  implements OnChanges, OnDestroy
{
  @Input() visible = false;
  @Input() itemName = '';
  @Input() drawingFileId: number | null = null;

  @Output() closed = new EventEmitter<void>();

  dialogVisible = false;
  loading = false;
  drawingFile: DrawingFile | null = null;
  errorMessage: string | null = null;

  private readonly drawingFileService = inject(DrawingFileService);
  private loadSubscription: Subscription | null = null;
  private loadGeneration = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']) {
      this.dialogVisible = this.visible;
    }

    if (!this.visible) {
      return;
    }

    if (changes['visible'] || changes['drawingFileId']) {
      this.loadDrawingFile();
    }
  }

  ngOnDestroy(): void {
    this.loadSubscription?.unsubscribe();
    this.loadSubscription = null;
  }

  onDialogHide(): void {
    this.dialogVisible = false;
    this.loading = false;
    this.errorMessage = null;
    this.drawingFile = null;
    this.loadSubscription?.unsubscribe();
    this.loadSubscription = null;
    this.closed.emit();
  }

  private loadDrawingFile(): void {
    this.loadGeneration += 1;
    const generation = this.loadGeneration;

    this.loadSubscription?.unsubscribe();
    this.drawingFile = null;
    this.errorMessage = null;

    if (this.drawingFileId == null) {
      this.errorMessage = 'No linked drawing file was found for this item.';
      return;
    }

    this.loading = true;
    this.loadSubscription = this.drawingFileService
      .getDrawingFile(this.drawingFileId)
      .subscribe({
        next: (drawingFile) => {
          if (generation !== this.loadGeneration) {
            return;
          }
          this.loading = false;
          this.drawingFile = drawingFile;
        },
        error: () => {
          if (generation !== this.loadGeneration) {
            return;
          }
          this.loading = false;
          this.errorMessage = 'Unable to load drawing details.';
        },
      });
  }
}
